"use strict";
exports.__esModule = true;
var MetricCollector = (function () {
    function MetricCollector() {
        this.metrics = this.getFreshMetrics();
    }
    MetricCollector.prototype.getFreshMetrics = function () {
        return {
            counters: {},
            timers: {},
            levels: {}
        };
    };
    MetricCollector.prototype.isEmpty = function () {
        return !Object.keys(this.metrics.counters).length &&
            !Object.keys(this.metrics.timers).length &&
            !Object.keys(this.metrics.levels).length;
    };
    MetricCollector.prototype.clearMetrics = function () {
        this.metrics = this.getFreshMetrics();
    };
    return MetricCollector;
}());
exports["default"] = MetricCollector;
//# sourceMappingURL=MetricCollector.js.map